<template>
     <q-card class="full-height bg-white">
        <q-card-title class="text-center bg-primary text-white">
            {{ $t('schedule') }}
        </q-card-title>

        <q-card-separator />

        <q-card-main class="relative-position">
            <full-calendar
                defaultView="listMonth"
                :plugins="calendarPlugins"
                :weekends="true"
                :events="events"
                ref="fullCalendar"
                :header="{
                    left: '',
                    center: 'title',
                    right: 'prev next'
                }"
                :titleFormat="{
                    month: 'short',
                    year: 'numeric',
                }"
                :locales="locales"
                :datesRender="datesRender"
                @dateClick="dateClicked"
                @click.native="dateClicked"
                :weekNumbers="true"
            />
        </q-card-main>

    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all'
import listPlugin from '@fullcalendar/list'

export default {
    data() {
        return{
            calendarPlugins: [dayGridPlugin, interactionPlugin, listPlugin],
            locales: allLocales,
            datesRender: this.monthChanged,
            first_load: false,
            selected_date: new Date,
            events: []
        }
    },

    computed: {
		...mapGetters({
			access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            languages: 'params/languages',
            reload_content: 'common/reload_content',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        dateClicked(val) {
            let item = this.events.find((e) => { return e.title === val.toElement.textContent})
            if (item) {
                if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
                    cordova.InAppBrowser.open(item.file_url, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                }
                else {
                    window.open(item.file_url, '_blank')
                }
            }
        },

        fetchAppointments() {
            this.$q.loading.show()

            let data = {
                'date': this.fDate(this.selected_date)
            }

            this.$axios.get(`/etraining_home/home_new/user_events/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {

                this.events = []

                let webcast =  response.data.webcast.map(e =>{
                    return {
                        ...e,
                        title: `${this.$t('webinars')} - ${e.title}`,
                        start: e.transmission_date
                    }
                })

                let calendar = response.data.calendar.map(e => {
                    return {
                        ...e,
                        title: `${this.$t('calendar')} - ${e.title}`,
                        start: e.date_start,
                        end: e.date_end
                    }
                })

                let presential = response.data.presential.map(e => {
                    return {
                        ...e,
                        title: `${this.$t('presential')} - ${e.title}`,
                        start: e.hr_start,
                        end: e.hr_end
                    }
                })

                this.events.push(...webcast, ...calendar, ...presential)
                return this.events

            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
                this.first_load = true
            })
        },

        monthChanged(val) {
            if (this.first_load) {
                this.first_load = false
                this.selected_date = this.$refs.fullCalendar.getApi().getDate()
                this.fetchAppointments()
            }
        },

        setCalendarLanguage() {
            let calendarApi = this.$refs.fullCalendar.getApi()

            let language = this.languages.find(l => {
                return l.id === this.id_user_language_selected
			})

			if (language) {
                calendarApi.setOption('locale', language.code)
			}
			else {
				calendarApi.setOption('locale', 'pt-br')
			}
        },

        fDate(d) {
            return date.formatDate(d, 'YYYY-MM-DD')
        }
    },

    watch: {
        reload_content: function() {
            this.first_load = false
            let date = `${new Date().getFullYear()}-${new Date().getMonth()+1}-01`
            this.selected_date = date
            setTimeout(() => {
                this.selected_date = date
                this.fetchAppointments()
            }, 0)
        }
    },

    mounted() {
        this.setCalendarLanguage()
        this.fetchAppointments()
    },

    created() {
        let date = `${new Date().getFullYear()}-${new Date().getMonth()+1}-01`
        setTimeout(() => {
            this.selected_date = date
        }, 0)
    }
}
</script>

<style lang="stylus">
    tr.fc-list-item
        cursor pointer !important
</style>>
